function setDayIndex(date, dayIndex) {
    var diff = dayIndex - date.getDay();
    date.setDate(date.getDate() + diff);
}
export function renderDayName(locale, dayIndex) {
    var tempDate = new Date();
    setDayIndex(tempDate, dayIndex);
    return tempDate.toLocaleDateString(locale, { weekday: 'short' });
}
export function renderMonthAndYear(locale, baseDate) {
    return baseDate.toLocaleDateString(locale, {
        year: 'numeric',
        month: 'long'
    });
}
export function renderDayLabel(locale, date) {
    return date.toLocaleDateString(locale, {
        weekday: 'long',
        month: 'short',
        day: 'numeric'
    });
}
//# sourceMappingURL=intl.js.map